<template>
  <section class="driver-recommend-info">

    <!-- START Search Box -->
    <div class="row">
      <div class="col-xl-12">
        <div class="card shadow">
          <div class="card-body">
            <div class="row">
              <div class="col-xl-3 col-lg-4">
                <b-form-group class="ct-mb-margin-bottom-100" label-class="col-form-label"
                              label="조회월" label-for="searchMonth"
                              label-cols="3" content-cols="9">
                  <date-picker id="searchMonth" v-model="selectedMonth"
                               type="month" value-type="YYYY-MM" append-to-body lang="ko"
                               :disabled-date="disabledAfterToday" @input="getStationOptions"/>
                </b-form-group>
              </div>
              <div class="col-xl-3 col-lg-4">
                <b-form-group class="ct-mb-margin-bottom-100" label-class="col-form-label"
                              label="충전소" label-for="searchStation"
                              label-cols="3" content-cols="9">
                  <multiselect id="searchStation" :disabled="isEmptyStationOptions"
                               v-model="selectedStation" :options="stationOptions"
                               label="text" :placeholder="statPlaceholder" :show-labels="false"
                               :allow-empty="false" deselect-label="" @input="getUserOptions">
                    <span slot="noResult">No Result</span>
                  </multiselect>
                </b-form-group>
              </div>
              <div class="col-xl-3 col-lg-4">
                <b-form-group class="ct-mb-margin-bottom-100" label-class="col-form-label"
                              label="이용자" label-for="searchUserId"
                              label-cols="3" content-cols="9">
                  <multiselect id="searchUserId" :disabled="isEmptyUserOptions"
                               v-model="selectedUserId" :options="userOptions"
                               :placeholder="userPlaceholder" :show-labels="false"
                               :allow-empty="false" deselect-label="" @input="search">
                    <span slot="noResult">No Result</span>
                  </multiselect>
                </b-form-group>
              </div>
<!--              <search-buttons layout-class="col-xl-4 ct-margin-top-25"-->
<!--                              resetBtnClass="search-btn-reset" searchBtnClass="search-btn-search"-->
<!--                              :reset-fn="reset" :search-fn="search" />-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Search Box -->

    <!-- START Driver Charge Use Pattern -->
    <div class="row">
      <div class="col-xl-12">
        <info-charge-use-pattern :searchArgs="searchArgs" />
      </div>
    </div>
    <!-- END Driver Charge Use Pattern -->

    <!-- START Driver Recommend Charge -->
    <div class="row">
      <div class="col-xl-12">
        <info-recommend-charge :searchArgs="searchArgs" />
      </div>
    </div>
    <!-- END Driver Recommend Charge -->

  </section>
</template>

<script>
import InfoChargeUsePattern from '@/views/pages/driver/infoChargeUsePattern.vue';
import InfoRecommendCharge from "@/views/pages/driver/infoRecommendCharge.vue";
import Multiselect from "vue-multiselect";
import { http } from "@/mdk/auth-api";
import SearchButtons from "@/views/components/searchButtons.vue";

export default {
  components: { SearchButtons, Multiselect, InfoChargeUsePattern, InfoRecommendCharge },
  data() {
    return {
      selectedMonth: moment().subtract(1,'months').format('YYYY-MM'),
      selectedStation: null,
      stationOptions: [],
      isEmptyStationOptions: true,
      selectedUserId: null,
      userOptions: [],
      isEmptyUserOptions: true,
      statPlaceholder: '',
      userPlaceholder: '충전소를 선택하세요',
      searchArgs: {
        month: null,
        userId: null,
        stationId: null,
      }
    }
  },
  mounted() {
    const vm = this;

    // setTimeout(() => {
    //   vm.selectedMonth = new Date(moment('2023-05', 'YYYY-MM'));
    // },200 )
    vm.getStationOptions();

  },
  methods: {
    disabledAfterToday(date) {
      const today = new Date();
      return date > new Date(today.setMonth(today.getMonth()-1));
    },
    async getStationOptions() {
      const vm = this;
      const _targetMonth = vm.selectedMonth;
      const _url = `/onmapi/charging-service/search/place/${_targetMonth}`;

      try {
        vm.stationOptions = [];
        vm.selectedStation = null;
        vm.userOptions = [];
        vm.selectedUserId = null;

        const res = await http.get(_url);

        vm.stationOptions = res.data.items.map(item => ({
          value: item.placeId,
          text: item.placeName
        }));

        if (vm.stationOptions.length > 0) {
          vm.isEmptyStationOptions = false;
          vm.statPlaceholder = '';
        } else {
          vm.isEmptyStationOptions = true;
          vm.statPlaceholder = '충전소 이용 내역이 없습니다';
          vm.isEmptyUserOptions = true;
          vm.userPlaceholder = '충전소를 선택하세요';
        }

      } catch (err) {
        console.error(err)
      }
    },
    async getUserOptions() {
      const vm = this;
      const _targetMonth = vm.selectedMonth;
      const _placeId = vm.selectedStation.value;
      const _url = `/onmapi/charging-service/search/user/${_targetMonth}/${_placeId}`;

      try {
        vm.userOptions = [];
        vm.selectedUserId = null;

        const res = await http.get(_url);

        vm.userOptions = res.data.items;

        if (vm.stationOptions.length > 0) {
          vm.isEmptyUserOptions = false;
          vm.userPlaceholder = '';
        } else {
          vm.isEmptyUSerOptions = true;
          vm.userPlaceholder = '이용자가 없습니다';
        }

      } catch (err) {
        console.error(err)
      }
    },
    // reset() {
    //   const vm = this;
    //
    //   vm.selectedMonth = new Date(moment('2023-05', 'YYYY-MM'));
    //   vm.selectedStation = null;
    //   vm.selectedUserId = null;
    // },
    search() {
      const vm = this;

      if (this.$_utils.isEmpty(vm.selectedStation)) {
        this.$swal('충전소를 선택하세요', '', 'warning');
        return false;
      } else if (this.$_utils.isEmpty(vm.selectedUserId)) {
        this.$swal('이용자 ID를 입력하세요', '', 'warning');
        return false;
      }

      vm.searchArgs = {
        month: vm.selectedMonth,
        stationId: vm.selectedStation.value,
        userId: vm.selectedUserId,
      };
    }
  }
}
</script>
